import { render, staticRenderFns } from "./DialogueEditor.vue?vue&type=template&id=f405f188&scoped=true&"
import script from "./DialogueEditor.vue?vue&type=script&lang=js&"
export * from "./DialogueEditor.vue?vue&type=script&lang=js&"
import style0 from "./DialogueEditor.vue?vue&type=style&index=0&id=f405f188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f405f188",
  null
  
)

export default component.exports